import {ComponentType, createContext, useContext} from 'react';
import {
  CustomPartConversationMessage,
  MessagePartData,
} from '@stripe-internal/conversations-client';
import {MessageComponentProps} from './MessageComponentContext';

export type MessagePartComponentProps<
  TMessage extends CustomPartConversationMessage = CustomPartConversationMessage,
  TPart extends MessagePartData = MessagePartData,
> = Omit<MessageComponentProps, 'message'> & {
  message: TMessage;
  part: TPart;
};

export type MessagePartComponentRegistry = Record<
  string,
  ComponentType<MessagePartComponentProps> | undefined
>;

export const MessagePartComponentContext =
  createContext<MessagePartComponentRegistry>({});

export function useMessagePartComponents() {
  return useContext(MessagePartComponentContext);
}
